"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var dropLast = function dropLast(array) {
  return array.slice(0, array.length - 1);
};

var _default = dropLast;
exports["default"] = _default;